<template>
	<th class="header" :class="cssClass" @click="clickHeader"><slot></slot></th>
</template>
<script>
	export default {
		name: 'TableHeader',
	   props: ['sort'],
		data() {
			return {
				canSort: !!this.sort,
				direction: this.sort
			}
		},
		computed: {
			cssClass() {
				if (!this.canSort || this.direction === 'none') return '';
				return (this.direction === 'descending') ? 'headerSortUp': 'headerSortDown';
			}
		},
		methods: {
			clickHeader(event) {
				if (!this.canSort) return;
				this.direction = (this.direction === 'none' || this.direction === 'descending') ? 'ascending' : 'descending';
				this.$emit('click-header', this.direction);

				//https://vuejs.org/v2/guide/migration.html#dispatch-and-broadcast-replaced
				//We use the parent as an event bus
				this.$parent.$emit('TableHeader:sortChanged', this);
			},
			sortChanged(element) {
				if (this === element) return;
				this.direction = 'none';
			}
		},		
		created() {
    		this.$parent.$on('TableHeader:sortChanged', this.sortChanged);
		},
		beforeDestroy: function () {
 			this.$parent.$off('TableHeader:sortChanged', this.sortChanged)
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/TableHeader.vue